import { useLocale } from '@mirai/locale';
import { Avatar, Button, Icon, Text, View } from '@mirai/ui';
import PropTypes from 'prop-types';
import React from 'react';

import { L10N } from './Header.l10n';
import * as style from './Header.module.css';
import { ICON } from '../../../helpers';
import { DEFAULT_NAME } from '../../Chat.constants';

const Header = ({ settings, onClose }) => {
  const { ai: { name = DEFAULT_NAME } = {}, web: { avatar } = {} } = settings || {};
  const { translate } = useLocale();

  return (
    <View row className={style.header}>
      <View row>
        <Avatar image={avatar} small className={style.avatar} />
        <View>
          <Text bold headline>
            {name}
          </Text>
          <Text light small>
            {translate(L10N.LABEL_ASSISTANT)}
          </Text>
        </View>
      </View>

      <Button small squared tooltip={translate(L10N.ACTION_CLOSE)} transparent onPress={onClose}>
        <Icon value={ICON.CLOSE} />
      </Button>
    </View>
  );
};

Header.propTypes = {
  settings: PropTypes.shape({
    ai: PropTypes.shape({
      name: PropTypes.string,
    }),
    web: PropTypes.shape({
      avatar: PropTypes.string,
    }),
  }),
  onClose: PropTypes.func,
  onRestart: PropTypes.func,
};

Header.displayName = 'Mirai:Core:Chat.Header';

export { Header };
